<template>
  <div class="section">
    <!-- 认知能力 -->
    <div class="title-info">
      考察对人才未来工作效率和质量产生关键影响力的能力素质项，可参考预测人才工作效率。
    </div>
    <div class="bg-container-boxer">
      <div class="bg"></div>
      <table class="bg-container" cellpadding="1" cellspacing="0">
        <tr>
          <td>
            <personalBar :model="this.model" />
          </td>
          <td style="vertical-align: top">
            <table class="table-content" cellspacing="0" cellpadding="0">
              <tr>
                <td
                  style="
                    text-align: center;
                    color: #29bdb9;
                    height: 20px;
                    font-size: 18px;
                    font-weight: bold;
                  "
                >
                  得分描述
                </td>
              </tr>
              <tr v-for="(item, index) in this.model" :key="index">
                <td>{{ item.content }}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import personalBar from "@/components/dataView/echarts/all/personalBar.vue";
export default {
  components: {
    personalBar,
  },
  props: ["model"],
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {

    if(this.model){
      this.model.map(item=>{
          if(item.score == 0){
            item.score = 0.12
          }
      })
    }
  },
  watch: {
    model(val) {
       if(this.model){
      this.model.map(item=>{
          if(item.score == 0){
            item.score = 0.12
          }
      })
    }
    }
  },
  methods: {
    loadData() {},
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-image: url("../../../assets/images/all/bd4/ge11.png");
  background-size: contain;
  background-repeat: no-repeat;
  height: 1124px;
  overflow: hidden;
  .title-info {
    padding: 270px 0 0 0;
    font-size: 14px;
    text-align: center;
  }
  .table-info {
    padding-top: 0px;
  }
  .table-content {
    margin-top: -29px;
    font-size: 14px;
    text-align: left;
    margin-right: 35px;
    width: 280px;
    td {
      height: 101px;
    }
  }
  .bg-container {

    // padding: 60px auto 50px;
  }
  .bg-container-boxer{
    position:relative;
    width:760px;
    margin:40px auto 39px;
    top:0;
    .bg-container{
      position: relative;
      z-index: 2;
      top:0px;
      left: 0px;;
    }
    .bg{
      position:absolute;
      background:url("../../../assets/images/all/bd4/ge2.png");
      background-repeat: no-repeat;
      z-index:0;
      height:100%;
      width:100%;
      top:0px;
      left: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/four/pageFive.vue